import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "ReviewSubmittedNotification" }
const _hoisted_2 = { class: "ReviewSubmittedNotificationContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-checkmark-circle ReviewSubmittedNotificationCheckmark" }, null, -1 /* CACHED */)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ReviewSubmittedNotificationTextContainer" }, [
        _createElementVNode("p", { class: "ReviewSubmittedNotificationText" }, " Thank you. Your review has been submitted! We will get in touch with you shortly to discuss the results and any questions you might have. ")
      ], -1 /* CACHED */)),
      _createElementVNode("button", {
        class: "NotificationCloseButton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissReviewSubmittedNotification && _ctx.dismissReviewSubmittedNotification(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
      ]))
    ])
  ]))
}